import { createReducer, on } from '@ngrx/store';
import { Formation } from '../../model/formation.model';
import { Occurrence } from '../../model/occurrence.model';
import * as FormationActions from '../actions/formation.actions';

export interface FormationState {
  formations: Formation[] | null;
  selectedFormation: Formation | null;
  nextOccurrence: Occurrence | null;
  loading: boolean;
  loadingDetail: boolean;
  loadingOccurrence: boolean;
  error: string | null;
}

export const initialState: FormationState = {
  formations: null,
  selectedFormation: null,
  nextOccurrence: null,
  loading: false,
  loadingDetail: false,
  loadingOccurrence: false,
  error: null,
};

export const formationReducer = createReducer(
  initialState,

  // Load formations list
  on(FormationActions.LoadFormations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FormationActions.LoadFormationsSuccess, (state, { formations }) => ({
    ...state,
    formations,
    loading: false,
    error: null,
  })),
  on(FormationActions.LoadFormationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Select formation — reset pour éviter données stale (Lilate, next occurrence) au switch
  on(FormationActions.SelectFormation, (state) => ({
    ...state,
    selectedFormation: null,
    nextOccurrence: null,
  })),
  on(FormationActions.ClearSelectedFormation, (state) => ({
    ...state,
    selectedFormation: null,
    nextOccurrence: null,
  })),

  // Load formation detail
  on(FormationActions.LoadFormationDetail, (state) => ({
    ...state,
    loadingDetail: true,
    error: null,
  })),
  on(FormationActions.LoadFormationDetailSuccess, (state, { formation }) => ({
    ...state,
    selectedFormation: formation,
    loadingDetail: false,
    error: null,
  })),
  on(FormationActions.LoadFormationDetailFailure, (state, { error }) => ({
    ...state,
    loadingDetail: false,
    error,
  })),

  // Load next occurrence
  on(FormationActions.LoadNextOccurrence, (state) => ({
    ...state,
    loadingOccurrence: true,
    error: null,
  })),
  on(FormationActions.LoadNextOccurrenceSuccess, (state, { occurrence }) => ({
    ...state,
    nextOccurrence: occurrence,
    loadingOccurrence: false,
    error: null,
  })),
  on(FormationActions.LoadNextOccurrenceFailure, (state, { error }) => ({
    ...state,
    loadingOccurrence: false,
    error,
  })),

  // Update formation
  on(FormationActions.UpdateFormation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FormationActions.UpdateFormationSuccess, (state, { formation }) => {
    const formations = state.formations.map(f => 
      f.id === formation.id ? formation : f
    );
    const selectedFormation = state.selectedFormation?.id === formation.id 
      ? formation 
      : state.selectedFormation;
    
    return {
      ...state,
      formations,
      selectedFormation,
      loading: false,
      error: null,
    };
  }),
  on(FormationActions.UpdateFormationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Clear state
  on(FormationActions.ClearFormationsState, () => initialState)
);
